import React from "react";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { CreateDateFilter } from "../shared/create-date-filter";

const LeadBulkActions = (props) => {
  const selectedRows = props.state.selectedRows;
  const superAdminOrAd = props.superAdminOrAd;

  return (
    <div id="lead-bulk-actions" key={props.disableAssignmentButtons}>
      {superAdminOrAd && (
        <Select
          key={`selectedOwner-${props.state.selectedOwner}`}
          className="owner-select"
          classNamePrefix="select"
          value={props.state.selectedOwner}
          options={props.ownerOptions}
          placeholder="Assign Lead"
          isDisabled={props.disableAssignmentSelect()}
          onChange={props.handleOwnerSelection}
        ></Select>
      )}

      <Select
        key={`outreach-stages`}
        className="stage-select"
        classNamePrefix="select"
        // value
        options={props.stageFilterOptions}
        placeholder="Change Lead Stage"
        isDisabled={props.disableStageAssignmentSelect()}
        onChange={props.handleLeadStageUpdate}
      ></Select>

      <div id="filterByCreateDate">
        <CreateDateFilter
          className="create-date-filter"
          value={props.state.createDates}
          onChange={props.handleCreateDatesChange}
        />
      </div>

      <div id="filterByStage">
        <Select
          className="stage-select"
          classNamePrefix="select"
          placeholder="Stage"
          isMulti
          options={props.stageFilterOptions}
          onChange={props.handleStageFilterChange}
          defaultValue={props.defaultStageFilters}
          value={props.state.stageFilterInput}
        ></Select>
      </div>

      {!props.qfsOnly && (
        <div id="filterByOrigin">
          <Select
            className="stage-select"
            classNamePrefix="select"
            placeholder="Origin"
            isMulti
            options={props.originFilterOptions}
            onChange={props.handleOriginFilterChange}
            defaultValue={props.defaultOriginFilters}
            value={props.state.originFiltersInput}
            key={`ownerFilters${props.state.originFiltersInput}`}
          ></Select>
        </div>
      )}

      {props.showOnlyMine || props.showMyTeamLeads || !props.superAdminOrAd ? (
        ""
      ) : (
        <div id="filterByOwner">
          <Select
            className="stage-select"
            options={props.ownerFilterOptions}
            placeholder="Owner"
            onChange={props.handleOwnerFilterChange}
            defaultValue={props.defaultOwnerFilters}
            value={props.state.ownerFiltersInput}
            isMulti
          ></Select>
        </div>
      )}
    </div>
  );
};

export default LeadBulkActions;
